<h2 i18n="@@section.communication">Contact</h2>

<mat-progress-bar *ngIf="loading else content"
                  mode="indeterminate">
</mat-progress-bar>

<ng-template #content>
  <h3 i18n="@@section.communication.contactEmail">Contact email</h3>

  <div class="alert alert-info"
       i18n="@@section.communication.infoMsg">
    If we need to reach you, we will use this email.
  </div>

  <form [formGroup]="form">
    <mat-radio-group [formControlName]="CommunicationForm.FIELD_EMAIL" color="primary">
      <div *ngFor="let option of emailOptions" class="email-option">
        <div class="email-option-row">
          <mat-radio-button [value]="option.email" [disabled]="!option.verified" color="primary">
            {{ option.email }}
          </mat-radio-button>
          <span class="provider-badge" *ngIf="option.providerName">
            <mat-icon *ngIf="option.providerIcon" [svgIcon]="option.providerIcon" class="provider-badge-icon"></mat-icon>
            {{ option.providerName }}
          </span>
          <span class="status-badge verified" *ngIf="option.verified">
            <mat-icon class="status-badge-icon">check</mat-icon>
            <ng-container i18n="@@common.verified">Verified</ng-container>
          </span>
          <span class="status-badge not-verified"
                *ngIf="!option.verified"
                i18n="@@common.notVerified">Not verified</span>
        </div>
        <p class="not-verified-hint"
           *ngIf="!option.verified"
           i18n="@@section.communication.emailNotVerifiedHint">
          This email comes from your login provider, but we can't confirm that you own it.
          To use an email as your contact email, it must be verified.
        </p>
      </div>
    </mat-radio-group>
  </form>

  <div class="form-actions">
    <button mat-flat-button
            color="primary"
            (click)="save()"
            [disabled]="saving || form.invalid || !hasVerifiedOptions">
      <ng-container *ngIf="!saving" i18n="@@common.action.save">Save</ng-container>
      <ng-container *ngIf="saving" i18n="@@common.action.saving">Saving...</ng-container>
    </button>
  </div>
</ng-template>
